import React, { useEffect, useState } from 'react';
import styles from './RedirectNode.module.scss';
import NodeContainer from '../customNodes/node-container/NodeContainer';
import { Handle, Position, useNodes } from '@xyflow/react';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import RedirectModal from './redirectModal/RedirectModal';
import { workflow } from 'hooks/endpoints';
import { useWorkflowContext } from 'app-context/worflow/WorkflowContext';
import { useFetch } from 'hooks/useFetch';

const RedirectNode = ({ id, selected, onNodesDelete, data, ...props }) => {
  const { workflowData } = useWorkflowContext();

  const nodes = useNodes();
  const node = nodes.find((node) => node.id === id);

  const [isError, setIsError] = useState(node?.is_Error || false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [redirectName, setRedirectName] = useState('');

  const { data: dataOptions, refetch: refetchData } = useFetch(
    ['workflowData', workflowData?.botId],
    workflow.getAllWorkflowsPaged,
    {
      enabled: !!workflowData?.botId,
    },
    {
      pageSize: 100,
      pageNumber: 1,
      botId: workflowData?.botId,
    }
  );
  useEffect(() => {
    refetchData();
  }, [workflowData?.botId]);

  useEffect(() => {
    if (dataOptions?.data?.items && node?.redirectNode?.redirectWorkflowId) {
      const foundVariable = dataOptions?.data?.items.find(
        (val) => val.id === node?.redirectNode?.redirectWorkflowId
      );
      setRedirectName(foundVariable?.name || 'workflow name');
    }
  }, [dataOptions, node?.redirectNode, node?.redirectNode?.redirectWorkflowId]);

  useEffect(() => {
    if (node?.redirectNode) {
      if (!node?.redirectNode?.redirectWorkflowId) {
        setIsError(true);
      } else {
        setIsError(false);
      }
    } else {
      setIsError(node?.is_Error || true);
    }
  }, [node?.redirectNode, node?.redirectNode?.redirectWorkflowId]);

  return (
    <>
      <NodeContainer
        name={node?.title || 'Redirect Block'}
        id={id}
        onClick={() => setIsModalOpen(true)}
        backgroundColor={node?.color}
        selected={selected}
        onNodesDelete={onNodesDelete}
        node={node}
        isError={isError}
      >
        <Handle
          className='custom-handle'
          type='target'
          position={Position.Left}
        />
        <div className={styles.svg}>
          <SvgWithBranding type='node-redirect' color='#787878' />
          {node?.redirectNode?.redirectWorkflowId ? (
            <p>{redirectName}</p>
          ) : (
            <p className={styles.placeholder}>Select Workflow</p>
          )}
        </div>

        <Handle
          type='source'
          className='custom-handle'
          position={Position.Right}
        />
      </NodeContainer>
      <RedirectModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title='Redirect'
        id={id}
        isError={isError}
      />
    </>
  );
};

export default RedirectNode;
